import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { AccessEntities } from "../AccessEntities";
import { RoleFullRow } from "namirasoft-access";
import PolicyTable from "../components/PolicyTable";

interface RoleViewPageProps extends NSARouterMakerResult, AccessProps { }

function RoleViewPage(props: RoleViewPageProps)
{
    return (
        <AccessLayout {...props}
            action={{
                title: "",
                description: "View the details of a role you've defined.",
                menus: {}
            }}
            pages={{
                entity: AccessEntities.role(props),
                view: {
                    ui: {
                        getChildrenAfter: (id, entity) =>
                        {
                            let e = entity as RoleFullRow;
                            if (e.policies.length > 0)
                                return <PolicyTable {...props} id={id} ids={e.policies as string[]} />
                            return null;
                        }
                    }
                }
            }}
        >
            <></>
        </AccessLayout>
    );
}

export default RoleViewPage;